
const initialState = {
    loading: false,
    newPass: false,
    error: false,
    tierListing:[],
    tierDetail:null
  };
  
  const tierReducer = (state = initialState, action) => {
    console.log("tier  reducers------", state,action);
   switch (action.type) {
     case "ADD_TIER_REQUEST":
       return {
         ...state,
         loading: true,
       };
     case "ADD_TIER_SUCCESS":
       return {
        ...state,
         loading: false,
         newPass: true,
         error: false,
       };
     case "ADD_TIER_FAILED":
       return {
        ...state,
         loading: false,
         newPass: false,
         error: true,
       };

       case "GET_TIER_REQUEST":
        return {
          ...state,
          loading: true,
        };
      case "GET_TIER_REQUEST_FAILED":
        return {
          ...state,
          error: true,
        };
      case "GET_TIER_REQUEST_SUCCESS":
        return {
          ...state,
          tierListing: action.payload,
          loading:false,
        };

      case "GOT_TIER_DETAIL":  
      return {
        ...state,
        tierDetail: action.payload,
      };
     default:
       return state;
   }
  };
  


  export default tierReducer;
  